<!--转发弹窗-->
<div class="m-full-model _currModel">
<div class="m-model-box m-forward" id="_transmitModel">
    <div class="m-model-top">
        <h2>转发动态</h2>
        <i class="icon iconfont icon-guanbi f-right _closeModelBtn"></i>
    </div>
    <div class="m-model-content">
        <div class="m-content-top">
            <div class="m-fw-tit">
                <p>@{{user}}: <span class="_currDynmMsg">{{msg}}</span></p>
                {{if isShowBtn}}
                <i class="icon iconfont icon-xialajiantou pub-arrow-xia m-drop-down _showFullTransmitMsgBtn"></i>
                {{/if}}
            </div>
        </div>
        <div class="m-fw-comment">
            <textarea class="_inputOwnMessageArea" name="" placeholder="点这里，把你的想法都表达出来吧..." maxlength="280"></textarea>
        </div>
        <div class="m-fw-func">
            <div class="m-fw-checkbox">
                <i class="icon iconfont _asCommentBtn"></i>同时作为评论发布
            </div>
            <div class="m-fw-btn">
                <span><a class="_currInputMessageCount">0</a>/280</span>
                <button class="m-model-btn m-push-btn _publishTransmitHandle" data-type="{{type}}">发布</button>
            </div>
        </div>
    </div>
</div>
</div>